import { Session, SupabaseClient, User } from '@supabase/supabase-js';
import { createContext, useContext } from 'react';
import { getGlobalData } from '../supabase/supabase';

class GlobalData {
    private data = {};

    public async get(key: string): Promise<any> {
        if (this.data[key] === undefined) {
            const res = await getGlobalData(key);
            if (res && res.length > 0) {
                this.data[key] = res[0].value;
            }
        }

        return this.data[key];
    }
}

export const GlobalContext = createContext<GlobalContextType>({
    session: null,
    user: null,
    // globalData: new GlobalData(),

    setSession: (session: Session) => {
        console.log('setSession function not set');
    },
    setUser: (user: User) => {
        console.log('setUser function not set.');
    }
});

export type GlobalContextType = {
    session: Session | null;
    user: User | null;
    // globalData: GlobalData;

    setSession(session: Session | null): void;
    setUser(user: User | null): void;
};

export const useGlobal = () => {
    return useContext(GlobalContext);
};
